<template>
  <div class="step3-payment">
    <!-- Header -->
    <div class="step3-payment__header">
      <div class="step3-payment__subtitle">
        Khách hàng thanh toán phí qua app hoặc chuyển khoản theo mã QR sau:
      </div>
    </div>

    <!-- Content -->
    <div class="step3-payment__content" style="margin-top: 10vh">
      <!-- Left: QR -->
      <div class="qr-card">
        <div class="qr-card__box">
          <img :src="infoQr.qrcode" class="qr-card__img" alt="QR code" />
        </div>
        <div style="margin: auto">
          <el-button type="text" class="qr-card__download" @click="downloadQR">
            <i class="el-icon-download"></i>
            Tải QR code
          </el-button>
        </div>

      </div>

      <!-- Right: Transfer info -->
      <div class="info-card">
       <h4 class="mb-2" style="font-weight: 600; color: #0a0a0a">Thông tin chuyển khoản</h4>

        <div class="info-row">
          <div class="info-label">Tên tài khoản</div>
          <div class="info-value" style="font-weight: 600">{{ infoQr.bank?.accountName }}</div>
        </div>

        <div class="info-row info-row--copy">
          <div class="info-label">Số tài khoản</div>
          <div class="info-value strong"><b>{{ infoQr.bank?.accountNumber }}</b></div>

          <el-button
              size="mini"
              class="btn-copy"
              @click="copyText(infoQr.bank?.accountNumber, 'Số tài khoản')"
          >
            <i class="el-icon-document-copy"></i>
            Sao chép STK
          </el-button>
        </div>

        <div class="info-row">
          <div class="info-label">Số tiền</div>
          <div class="info-value strong"><b>{{ formatMoney(infoQr.amount) }}</b></div>
        </div>

        <div class="info-row info-row--copy">
          <div class="info-label">Nội dung</div>
          <div class="info-value strong"><b>{{ infoQr.description }}</b></div>

          <el-button
              size="mini"
              class="btn-copy"
              @click="copyText(infoQr.description, 'Nội dung')"
          >
            <i class="el-icon-document-copy"></i>
            Sao chép
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {GET_INFO_QR_CITIME} from "../../../../core/services/store/customer/customer-crm.module";

export default {
  name: "step3HandleFileContract",

  data() {
    return {
      infoQr: [],
    };
  },
  mounted() {
    this.getInfoQr();
  },
  methods: {
    getInfoQr() {
      this.$store.dispatch(GET_INFO_QR_CITIME, {id: this.$route.params.id})
          .then((res) => {
            let data = res.data;
            this.infoQr = data;
            this.infoQr.qrcode =
                 `https://qr.sepay.vn/img?bank=${data?.bank?.bankName.trim()}&acc=${data?.bank?.accountNumber.trim()}&template=compact&des=${data?.description.trim()}&amount=${data?.amount}`;
          })
          .catch((error) => {

          });

    },
    formatMoney(v) {
      const n = Number(v || 0);
      return n.toLocaleString("vi-VN");
    },

    async copyText(text, label = "Nội dung") {
      const value = String(text ?? "");
      if (!value) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(value);
        } else {
          // Fallback
          const ta = document.createElement("textarea");
          ta.value = value;
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }

        this.$message.success(`${label} đã được sao chép!`);
      } catch (e) {
        this.$message.error("Không sao chép được, thử lại giúp mình nha 😅");
      }
    },

    async downloadQR() {
      try {
        const res = await fetch(this.infoQr.qrcode, { mode: "cors" });
        if (!res.ok) throw new Error("Thất bại!");

        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "qr-code.png";
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      } catch (e) {
        window.open(this.qrUrl, "_blank");
        this.$message.warning("Không tải được do CORS, mình mở QR ở tab mới nhé.");
      }
    }
  },
};
</script>


<style scoped>
.step3-payment {
  width: 100%;
}

/* Header giống ảnh: canh giữa */
.step3-payment__header {
  text-align: center;
  margin-bottom: 18px;
}
.step3-payment__title {
  font-weight: 700;
  font-size: 18px;
}
.step3-payment__subtitle {
  margin-top: 6px;
  color: #6b7280;
  font-size: 13px;
}

/* Layout 2 cột */
.step3-payment__content {
  display: flex;
  gap: 18px;
  justify-content: center;
  align-items: flex-start;
}

/* QR card */
.qr-card {
  width: 260px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.qr-card__box {
  width: 260px;
  height: 260px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-card__img {
  width: 220px;
  height: 220px;
  object-fit: contain;
}
.qr-card__download {
  margin-top: 10px;
  padding: 0 !important;
  color: #111827;
  font-weight: 600;
}
.qr-card__download i {
  margin-right: 8px;
}

/* Info card */
.info-card {
  width: 50%;
  max-width: calc(100vw - 320px);
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 18px;
  background: #fff;
  text-align: left;
  height: -webkit-fill-available;
}
.info-card__title {
  font-weight: 700;
  margin-bottom: 12px;
}

/* Rows */
.info-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 10px 14px;
  align-items: center;
  padding: 8px 0;
}
.info-row--copy {
  grid-template-columns: 110px 1fr auto;
}

.info-label {
  color: #111827;
  font-size: 13px;
}
.info-value {
  color: #111827;
  font-size: 13px;
}
.info-value.strong {
  font-weight: 700;
}

/* Copy button giống ảnh */
.btn-copy {
  border: 1px dashed #f0c78a !important;
  background: #fff7ed !important;
  color: #111827 !important;
  border-radius: 8px !important;
  font-weight: 600;
}
.btn-copy i {
  margin-right: 6px;
}

/* Responsive */
@media (max-width: 1024px) {
  .step3-payment__content {
    flex-direction: column;
    align-items: center;
  }
  .info-card {
    width: 100%;
    max-width: 560px;
  }
  .qr-card {
    align-items: center;
  }
}
</style>


